/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { IceNavService } from '../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss'],
  providers: [AppService, IceNavService]
})
export class SitemapComponent implements OnInit {

  constructor(private appSvc: AppService) {
    appSvc.defaultMenus();
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }
}
